export const initialState = {
  isOpen: false,
}

export const setOpen = (state, payload) => ({
  isOpen: payload,
})
